
import React from 'react';
import './css/SalesforceSolutions.css';
import { HashLink as Link } from "react-router-hash-link";
const cards = [
  {
    id: 1,
    title: 'Salesforce Health Cloud',
    desc: 'for patient, providers and medications management',
    color: '#2C58ED',
    url: "/services/salesforce-health-cloud"
  },
  {
    id: 2,
    title: 'Salesforce CPQ Cloud',
    desc: 'for quote, billing, inventory and subscriptions',
    color: '#153AC9',
    url: "/services/salesforce-revenue-cloud-cpq"
  },
  {
    id: 3,
    title: 'Salesforce Experience Cloud',
    desc: 'to fast go-to-market with your e-commerce store',
    color: '#9B1EA4',
    url: "/services/salesforce-experience-cloud"
  },
  {
    id: 4,
    title: 'Salesforce Marketing Cloud',
    desc: 'to personalize the customer experiences',
    color: '#2035B5',
    url: "/services/salesforce-marketing-cloud"
  },
];

export default function OurIndustry() {
  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div className='container'>
        <div className="salesforceSection ">
          <p className="sectionLabel">FEATURED SERVICES</p>
          <h2>
            Our Industry-tailored <span>Salesforce</span> solutions
          </h2>
          <div className="salesforceGrid">
            {cards.map((card, idx) => (
              <Link to={card.url} className="salesforceCard" style={{
                backgroundColor: card.color, listStyle: "none",
                textDecoration: "none"
              }} key={card.id}>
                <h4>{card.title} <span>{card.desc}</span> </h4>
                <div className="readMore">
                  Read More <span>→</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

